import React from 'react';
import { FaEye, FaBan, FaCheckCircle, FaEdit, FaTrash } from 'react-icons/fa';

function UserTable({ users, onView, onBan, onUnban, onEditPoints, onDelete, selectedIds, onToggleSelect, onToggleSelectAll }) {
  const hasSelection = !!selectedIds;
  return (
    <div style={styles.tableContainer}>
      <table style={styles.table}>
        <thead>
          <tr style={styles.headerRow}>
            {hasSelection && (
              <th style={styles.th}>
                <input
                  type="checkbox"
                  checked={users.length > 0 && selectedIds.size === users.length}
                  onChange={onToggleSelectAll}
                />
              </th>
            )}
            <th style={styles.th}>ID</th>
            <th style={styles.th}>Avatar</th>
            <th style={styles.th}>Ad Soyad</th>
            <th style={styles.th}>Username</th>
            <th style={styles.th}>Email</th>
            <th style={styles.th}>Xallar</th>
            <th style={styles.th}>Check-ins</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>Qoşulma</th>
            <th style={styles.th}>Əməliyyatlar</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.id} style={styles.row}>
              {hasSelection && (
                <td style={styles.td}>
                  <input
                    type="checkbox"
                    checked={selectedIds.has(user.id)}
                    onChange={() => onToggleSelect(user.id)}
                  />
                </td>
              )}
              <td style={styles.td}>{String(index + 1).padStart(3, '0')}</td>
              <td style={styles.td}>
                <img
src={user.avatar_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.full_name || 'User')}&background=FF6B35&color=fff&size=40`}
                  alt={user.full_name}
                  style={styles.avatar}
                />
              </td>
              <td style={styles.td}>
                <strong>{user.full_name}</strong>
              </td>
              <td style={styles.td}>@{user.username}</td>
              <td style={styles.td}>{user.email}</td>
              <td style={styles.td}>
                <span style={styles.points}>{user.points || 0}</span>
              </td>
              <td style={styles.td}>
                <strong>{user.total_checkins || 0}</strong>
              </td>
              <td style={styles.td}>
                {user.is_banned ? (
                  <span style={styles.statusBanned}>🚫 Ban</span>
                ) : (
                  <span style={styles.statusActive}>✅ Aktiv</span>
                )}
              </td>
              <td style={styles.td}>
                {new Date(user.created_at).toLocaleDateString('az-AZ')}
              </td>
              <td style={styles.td}>
                <div style={styles.actions}>
                  <button
                    onClick={() => onView(user)}
                    style={styles.btnView}
                    title="Bax"
                  >
                    <FaEye />
                  </button>

                  {user.is_banned ? (
                    <button
                      onClick={() => onUnban(user)}
                      style={styles.btnUnban}
                      title="Unban"
                    >
                      <FaCheckCircle /> Unban
                    </button>
                  ) : (
                    <button
                      onClick={() => onBan(user)}
                      style={styles.btnBan}
                      title="Ban et"
                    >
                      <FaBan /> Ban
                    </button>
                  )}

                  <button
                    onClick={() => onEditPoints(user)}
                    style={styles.btnEdit}
                    title="Xalları dəyiş"
                  >
                    <FaEdit />
                  </button>

                  <button
                    onClick={() => onDelete(user)}
                    style={styles.btnDelete}
                    title="Sil"
                  >
                    <FaTrash />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {users.length === 0 && (
        <div style={styles.noData}>
          <p>Heç bir istifadəçi tapılmadı</p>
        </div>
      )}
    </div>
  );
}

const styles = {
  tableContainer: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    overflow: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1200px',
  },
  headerRow: {
    backgroundColor: '#F8F9FA',
  },
  th: {
    padding: '15px',
    textAlign: 'left',
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#666',
    textTransform: 'uppercase',
    borderBottom: '2px solid #E0E0E0',
    whiteSpace: 'nowrap',
  },
  row: {
    borderBottom: '1px solid #F0F0F0',
    transition: 'background-color 0.2s',
  },
  td: {
    padding: '15px',
    fontSize: '14px',
    color: '#1A1A2E',
    whiteSpace: 'nowrap',
  },
  avatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  points: {
    padding: '5px 12px',
    backgroundColor: '#FFF3E0',
    color: '#F57C00',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  statusActive: {
    padding: '5px 12px',
    backgroundColor: '#E8F5E9',
    color: '#2E7D32',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
  },
  statusBanned: {
    padding: '5px 12px',
    backgroundColor: '#FFEBEE',
    color: '#C62828',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
  },
  actions: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  btnView: {
    padding: '8px 12px',
    backgroundColor: '#2196F3',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'all 0.3s',
  },
  btnBan: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '8px 12px',
    backgroundColor: '#F44336',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    transition: 'all 0.3s',
  },
  btnUnban: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '8px 12px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    transition: 'all 0.3s',
  },
  btnEdit: {
    padding: '8px 12px',
    backgroundColor: '#FF9800',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'all 0.3s',
  },
  btnDelete: {
    padding: '8px 12px',
    backgroundColor: '#9E9E9E',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'all 0.3s',
  },
  noData: {
    padding: '40px',
    textAlign: 'center',
    color: '#999',
  },
};

export default UserTable;